import { render, staticRenderFns } from "./makeplogskill.vue?vue&type=template&id=57c7852e&scoped=true&"
import script from "./makeplogskill.vue?vue&type=script&lang=js&"
export * from "./makeplogskill.vue?vue&type=script&lang=js&"
import style0 from "./makeplogskill.vue?vue&type=style&index=0&id=57c7852e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7852e",
  null
  
)

export default component.exports